// Panel GLOBAL del BOX 5 — lista todos los chars PvE conectados.
// Info pública mínima por privacy: name + level + clase/raza + color
// del nombre (mismo color que se usa in-world). NO se muestra HP, mana,
// posición ni mapa — diferencia clave con el panel del Party.
//
// Mismo lenguaje visual que el PartyPanel: header "GLOBAL ---- N online"
// con la receta del itemsHeader, list de rows compactas.
//
// React.memo nativo. El parent (play/index.js) memoiza el elemento JSX
// via `_getCachedGlobalPanelEl` con fingerprint sobre el array de globalList
// — solo invalida cuando el server manda un partyState nuevo.

import React from "react";
import { nameClases, nameRazas } from "../../config/config";

function GlobalPanel({ style, list, onRowContextMenu }) {
    const items = Array.isArray(list) ? list : [];
    return (
        <div className={style.partyPanel}>
            <div className={style.partyPanelHeader}>
                <span className={style.partyPanelTitle}>Global</span>
                <span className={style.partyPanelRule} />
                <span className={style.partyPanelCount}>
                    {items.length} online
                </span>
            </div>

            {items.length === 0 ? (
                // Empty state DENTRO del container fijo — el panel mantiene
                // la altura de 8 filas aunque no haya data, así el header
                // siempre cae en el mismo Y.
                <div className={style.globalMembersList}>
                    <div className={style.partyEmpty}>Cargando jugadores…</div>
                </div>
            ) : (
                <div className={style.globalMembersList}>
                    {items.map((m, idx) => {
                        const cls = nameClases[m.idClase] || "—";
                        const rz = nameRazas[m.idRaza] || "—";
                        const nameColor = m.color || "#3333ff";
                        const onCtx = onRowContextMenu
                            ? e => onRowContextMenu(e, m.name)
                            : undefined;
                        return (
                            <div
                                key={m.name + "_" + idx}
                                className={style.globalRow}
                                onContextMenu={onCtx}
                                title="Click derecho: Susurrar / Invitar a party"
                            >
                                <span className={style.globalColLvl}>
                                    {m.level || "?"}
                                </span>
                                <span
                                    className={style.globalColName}
                                    style={{ color: nameColor }}
                                    title={m.name}
                                >
                                    {m.name}
                                </span>
                                <span
                                    className={style.globalColClassRace}
                                    title={cls + "/" + rz}
                                >
                                    {cls.slice(0, 4)}/{rz.slice(0, 4)}
                                </span>
                                <span
                                    className={style.globalColMap}
                                    title={m.mapName || "Ubicación oculta"}
                                >
                                    {m.mapName || "-"}
                                </span>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default React.memo(GlobalPanel);
